// src/zong/MobileInsurance.js
import React,{ useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import '../Styles/background.css'; // Import the CSS file

const MobileInsurance = () => {

    const [data, setData] = useState(null); // State to hold API response
    const [loading, setLoading] = useState(true); // State to handle loading state
    const [error, setError] = useState(null); // State to handle error
    const navigate = useNavigate(); // Initialize useNavigate

    const handleSubscribe = () => {
        navigate('/mobile-otp'); // Navigate to the MobileOTP page
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('http://115.42.72.186:8088/HE/index.php'); // Replace with your API URL
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                alert(response);
                const result = await response.json();
                setData(result); // Set the API response data
                console.log(data);
            } catch (error) {
                setError(error.message); // Set any errors
            } finally {
                setLoading(false); // Set loading to false
            }
        };

        fetchData();
    }, []); // Empty dependency array means this effect runs once on mount

    // Conditional rendering based on loading, error, or data
    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="mobile-insurance d-flex flex-column justify-content-end align-items-center">
            

            <div className='row' style={{ width: '100%', maxWidth: '400px' }}>
                <div className='col-12 mb-3  d-flex flex-column justify-content-end align-items-center'>
                    <input className='form-control rounded-pill' type="text" placeholder='Cell # 031xxxxxxxx' value={data.msisdn} />
                </div>
                <div className='col-12'>
                    <button className='btn btn-primary w-100 rounded-pill' onClick={handleSubscribe}>Subscribe</button>
                </div>
            </div>
        </div>
    );
};

export default MobileInsurance;
